import { render, staticRenderFns } from "./Preiserfassung.vue?vue&type=template&id=85c8fe9a&"
import script from "./Preiserfassung.vue?vue&type=script&lang=js&"
export * from "./Preiserfassung.vue?vue&type=script&lang=js&"
import style0 from "./Preiserfassung.vue?vue&type=style&index=0&id=85c8fe9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports